import React from 'react';
import { Helmet } from 'react-helmet';

const HrefLangManager = ({ alternates }) => {
	return (
		<Helmet>
			{alternates.map((alternate, i) => (
				<link key={i} rel="alternate" hreflang={alternate[0]} href={alternate[1]} />
			))}
		</Helmet>
	);
};

export default HrefLangManager;
